import PedsReview from '../components/PedsReview/PedsReview';
import PedsReviewDetail from '../components/PedsReview/PedsReviewDetail';

const PEDS_REVIEW_ROUTES = [
  {
    id: 'pedsReview',
    path: '/peds-review',
    exact: true,
    component: PedsReview
  },
  {
    id: 'pedsReviewDetail',
    path: '/peds-review/:id',
    exact: true,
    component: PedsReviewDetail
  }
];

export default PEDS_REVIEW_ROUTES;
